import React from "react";
import { SHr, SNavigation, SPage, SPopup, SText, STheme, SView } from "servisofts-component2";
// import BottomNavigator from "../../Components/BottomNavigator";
import PButtom from "../../Components/PButtom";
import Input from "../../Components/Input";
import { StyleSheet } from "react-native";
import CryptoJS from 'crypto-js';
import MDL from "../../MDL";

import InputPassword from "../../Assets/svg/password.svg"

export default class recuperar_pass extends React.Component {
    // static FOOTER = <BottomNavigator url={"/login"} />
    constructor(props) {
        super(props);
        this.state = {
        };
        this.user_to_rec = SNavigation.getAllParams();
    }
    alertErrorPassword() {
        return <SView col={"xs-11 md-8 xl-6"} row center style={{ height: 250, borderRadius: 8, }} backgroundColor={STheme.color.background} >
            <SView col={"xs-11"} height={40} />
            <SView col={"xs-11"} center >
                <InputPassword name={"InputPassword"} height={100} width={100} fill={STheme.color.secondary} />
            </SView>
            <SView col={"xs-11"} height={15} />
            <SView col={"xs-12"} center  >
                <SText center color={STheme.color.text} style={{ fontSize: 18, fontWeight: "bold" }}>Las contraseñas no coinciden</SText>
            </SView>
            <SView col={"xs-11"} height={30} />
        </SView>
    }

    inputRefs = {};
    getForm() {
        return <>
            {/* <SForm
                ref={(ref) => { this.form = ref; }}
                row
                style={{
                    justifyContent: "space-between",
                }}
                inputProps={{
                    col: "xs-12",
                }}
                inputs={{
                    correo: { placeholder: "email@example.com", type: "email", isRequired: true },
                }}
                onSubmit={(values) => {
                    Model.usuario.Action.recuperarPass({ correo: values.correo }).then(resp => {
                        SNavigation.navigate("/login/recuperar_codigo");
                    }).catch(e => {
                        console.error(e);
                    })
                }}
            /> */}
            <Input
                ref={(ref) => this.inputRefs["Password"] = ref}
                type="password"
                required
                placeholder="Introduce tu nueva contraseña"
                style={styles.input}
            />
            <SHr />
            <Input
                ref={(ref) => this.inputRefs["RepPassword"] = ref}
                type="password"
                required
                placeholder="Confirma tu nueva contraseña"
                style={styles.input}
            />
            <SView height={16} />
            <SView col={"xs-11"} row center>
                <PButtom primary onPress={() => {
                    let data = {};
                    let vacio = false;
                    let password = this.inputRefs["Password"];
                    let repPassword = this.inputRefs["RepPassword"];

                    if (!password.validar() || !repPassword.validar()) {
                        vacio = true;
                        SPopup.alert("Por favor, introduce tu nueva contraseña.");
                        return;
                    }

                    if (password.getValue() != repPassword.getValue()) {
                        SPopup.open({ content: this.alertErrorPassword() });
                        return null;
                    }

                    if (!vacio) {
                        // let pass = CryptoJS.MD5(password.getValue()).toString();
                        let pass = password.getValue();
                        MDL.usuario.cambiarPassByCodigo(
                            pass,
                            this.user_to_rec
                        ).then((resp) => {
                            if (resp.estado === "exito") {
                                SNavigation.reset("/login")
                            } else {
                                SPopup.alert("Error en los datos");
                            }
                        }).catch((e) => {
                            console.error(e);
                            SPopup.alert("Error en los datos");
                        })
                        // console.log("data", data);

                    }


                }}>Restablecer Contraseña</PButtom>
            </SView>
        </>
    }

    render() {
        return <SPage title={"Registrar nueva contraseña"}>
            <SView center>
                <SView col={"xs-11 md-6 xl-4"} center>
                    <SView height={40} />
                    <SText fontSize={24} color={STheme.color.text} center>¡Restablece tu contraseña!</SText>
                    <SView height={30} />

                    {this.getForm()}

                    <SView height={36} />
                </SView>
            </SView>
        </SPage>
    }
}
const styles = StyleSheet.create({
    input: {
        width: "100%",
    },
});